/* eslint-disable max-len */
import { CollapsibleListProps } from 'src/components/TerapiRegeneratif/CollapsibleList';

const panelsData: CollapsibleListProps['panels'] = [
	{
		header: 'Apa itu stem cells?',
		children: `<ul>
		<li>
			Stem cells di indonesia dikenal juga dengan sel punca merupakan basis dari semua sel yang ada di dalam tubuh kita. Bedanya dengan sel pada umumnya, stem cell memiliki kemampuan untuk meregenerasi diri sendiri secara berulang kali. Memiliki potensi untuk berdiferensiasi menjadi sel/jarignan/organ tubuh yang lebih spesifik.
		</li>
	</ul>`,
		key: 'steam-cell-meaning',
	},
	{
		header: 'Apa saja tipe stem cell?',
		children: `<ul>
		<li>Berasal dari embryo yang berusia 5 hari setelah pembuahan.</li>
		<li>
			Pluripotent: Sel memiliki kemampuan untuk berproliferasi menjadi sel apapun di dalam
			tubuh.
		</li>
		<li>Memiliki kemampuan proliferasi yang tinggi.</li>
		<li>
			Tidak digunakan untuk terapi sel karena berpotensi menginduksi tumor jika disuntikan ke
			dalam tubuh.
		</li>
		<li>
			Adult stem cells/tissue specific stem cell: Tipe stem cell yang digunakan untuk terapi
			sel.
		</li>
		<li>Multipotent: Sel memiliki kemampuan yang lebih terbatas untuk memperbanyak diri.</li>
		<li>Tipe adult stem cell untuk terapi sel: Mesenchymal stem cell (MSC)</li>
		<li>Adult/tissue stem cell yang telah diprogram sehingga memiliki sifat “pluripotent”</li>
		<li>Pada saat ini, aplikasi lebih banyak untuk riset di laboratorium</li>
		<li>
			Apakah yang dimaksud dengan pengobatan regeneratif (Regenerative Medicine)? Pengobatan
			regeneratif berfokus pada pengembangan dan penerapan obat-obatan baru untuk memperbaiki
			jaringan dan organ serta mengembalikan fungsi dengan penerapan prinsip regenerasi
		</li>
		<li>
			Jenis stem cell yang saat ini sudah banyak dimanfaatkan untuk aplikasi klinis? Sel punca
			mesenkimal/mesenchymal stem cell (MSC)
		</li>
		<li>
			Sumber MSC yang paling sering dimanfaatkan? Sumsum tulang (bone marrow), jaringan lemak
			dan jaringan tali pusat.
		</li>
		<li>
			Indikasi apa saja yang biasa di treatment dengan MSC? Saat ini stem cell sudah banyak
			dimanfaatkan untuk penyakit degeneratif, degenerasi saraf (stroke, Parkinson, Alzheimer),
			radang sendi, penyakit autoimun
		</li>
	</ul>`,
		key: 'stem-cell-types',
	},
	{
		header: 'Bagaimana cara kerja stem cell?',
		key: 'stem-cell-how-to',
		children: `<ul>
			<li>
				Paska diinjeksikan ke tubuh pasien stem cell dapat mengenal area yang rusak atau mengalami
				inflamasi dan migrasi ke area tersebut “Homing”
			</li>
			<li>
				Sekresi zat molekul bioaktif yang berfungsi sebagai signal bagi sel-sel lain untuk
				berdiferensiasi dan proliferasi.
			</li>
		</ul>
	`,
	},
	{
		header: 'Apa saja jenis terapi stem cell?',
		key: 'stem-cell-therapist',
		children: `
			<p>Autologous:</p>
			<ul>
				<li>
				<p>Menggunakan sel yang berasal dari tubuh pasien, diekspansi untuk </p>
					mencapai jumlah tertentu dan disuntikan ke dalam tubuh pasien
					yang sama
				</li>
			</ul>
			<p>Alogenik:</p>
			<ul>
				<li>
					Sumber stem cell diambil dari donor, diolah dan ekspansi untuk kemudian dapat digunakan
					oleh pasien lain.
				</li>
				<li>
					Lebih nyaman untuk pasien karena tidak memerlukan biopsy sumsum tulang/jaringan lemak,
					juga mengurangi resiko kegagalan kultur. Source: ispe.org
				</li>
			</ul>
		`,
	},
	{
		header: 'Hal apa saja yang perlu diperhatikan dalam terapi stem cell?',
		key: 'stem-cell-things',
		children: `<ul>
			<li>Status laboratorium penyedia stem cell – apakah sudah mendapatkan sertifikasi cGMP</li>
			<li>
				<b>Sumber stem cell: </b>
				<p>
					Apakah dari manusia, hewan atau tumbuhan. Untuk terapi sel sangat direkomendasikan
					sumber sel berasal dari manusia untuk mengurangi resiko ketidakcocokan saat penyuntikan.
				</p>
			</li>
			<li>
				<b>Bentuk dari stem cell tersebut: </b>
				<p>
					Larutan suspensi sel biasa dikemas dalam wadah steril dalam suhu tertentu dan hanya
					dapat bertahan dalam waktu yang singkat. Sel tidak bisa dikemas dalam bentuk
					bubuk/tablet/krim.
				</p>
			</li>
		</ul>`,
	},
	{
		header: 'Bagaimana terapi stem cell untuk anti-aging?',
		key: 'stem-cell-therapy',
		children: `
		<ul>
			<li>
				Kualitas dan jumlah stem cell menurun seiring dengan bertambahnya usia, sehingga proses
				penyembuhan pada orang tua cenderung memakan waktu yang lebih lama.
			</li>
			<li>
				Injeksi stem cell pada orang yang sudah berumur diharapkan dapat mempercepet proses
				perbaikan sel-sel yang rusak dan mengurangi inflamasi di dalam tubuh.
			</li>
		</ul>`,
	},
];

export default panelsData;
